<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["tag_details"] }}
        </p>
      </div>
      <p class="content_title_center tag-number">
        {{ tag.number }}
      </p>

      <p class="content_title_center">
        {{ tag.vehicle.make }} {{ tag.vehicle.model }}
      </p>
      <p class="content_title_center barcode-text">
        {{ tag.barcode }}
      </p>
      <barcode
        v-model="tag.barcode"
        class="barcode"
        :options="{
          displayValue: true
        }"
      ></barcode>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.tag = this.$store.getters.SELECTED_RESIDENT_TAG;
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      requestType: "PARKENDA",
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      residentTags: [],
      next: (item) => {
        console.log("Selected tag =", item);
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
}
.barcode {
  width: 60%;
  margin: 5px auto;
  border: 2px solid rgba(114, 174, 255, 1);
  padding: 10px;
  border-radius: 25px;
}
.tag-number {
  margin: 6vh auto 1.5vh auto;
}
.barcode-text {
  margin: 1.5vh auto 4vh auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Residential/TagDetails.vue